import 'css-chunksrc/client/common/constraintTypeForm/styles.scss';export default {
  "constraintTypeForm": "_constraintTypeForm_1q91f_1",
  "text": "_text_1q91f_14"
};